import type { ShipmentStatus } from '@lib/api';

/** Unloading is finished (with or without missing cylinders). */
export const isReceived = (status: ShipmentStatus) => status === 'RECEIVED' || status === 'RECEIVED_WITH_DISCREPANCY';
